// test2452
(2452 && 0);
